module.exports = __webpack_public_path__ + "static/img/titleLogo.feb57882.png";